import { IconMessageCircle } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import './RequestFeatureTab.scss';

const CANNY_URL = 'https://northspyre.canny.io/deal-feature-requests';

const RequestFeatureTab: React.FC = () => (
    <a
        href={CANNY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="ns-request-feature-tab cursor--pointer position-fixed"
    >
        <div className="ns-request-feature-tab__inner d-inline-flex text-dark">
            <NSIcon className="ns-request-feature-tab__icon mr-2" icon={IconMessageCircle} />
            <span className="ns-request-feature-tab__text font-weight-bold">Request feature</span>
        </div>
    </a>
);

export default RequestFeatureTab;
